<template>
  <div
    :key="step"
    class="mt-4 flex flex-wrap items-center lg:flex-nowrap">
    <p
      v-if="step === 0"
      class="mb-4 text-sm font-normal text-gray-300 lg:mb-0 lg:text-base">
      {{ step1.mandatory }}
    </p>
    <button
      v-else
      class="group order-2 flex items-center lg:order-1"
      @click="emit('changeStep', 0)">
      <IconArrowRight class="mx-2 h-6 w-6 rotate-180 transition group-hover:-translate-x-1.5" />
      <p class="hidden text-gray-600 lg:block">
        {{ step2.back }}
      </p>
    </button>
    <Presence>
      <Motion
        v-if="state === 'error'"
        :initial="{ opacity: 0 }"
        :animate="{ opacity: [0, 1] }"
        :exit="{ opacity: 0 }"
        class="order-1 mx-6 mb-3 ml-auto flex items-center text-sm text-red-400 lg:order-2 lg:mb-0 lg:text-base">
        <IconExclamationMark class="mr-2 h-5 w-5 fill-current text-red-400" />{{ errorMsg }}
      </Motion>
    </Presence>
    <JobModalButton
      :label="step === 0 ? step1.cta : step2.cta"
      class="order-3 ml-auto lg:mt-0"
      :state="state"
      @click="emit('handleButtonClick')" />
  </div>
</template>

<script lang="ts" setup>
  // @ts-nocheck
  import { Motion, Presence } from '@motionone/vue/dist/motion-vue.ssr.js'

  import type { FormStateType } from '~/models/form'

  type ModalButtonsProps = {
    step1: {
      cta: string
      mandatory: string
    }
    step2: {
      cta: string
      back: string
    }
    step: number
    errorMsg: string
    state: FormStateType
  }

  defineProps<ModalButtonsProps>()
  const emit = defineEmits(['handleButtonClick', 'changeStep'])
</script>
